import { loadTone } from './loadTone';
// Your memoized Tone.js loader
import { ToneModuleType } from './types';

export type SamplerInstance = InstanceType<ToneModuleType['Sampler']>;

const globalSamplers: Record<string, Promise<SamplerInstance>> = {};

export async function getSampler(note: string): Promise<SamplerInstance> {
  if (!globalSamplers[note]) {
    globalSamplers[note] = loadTone().then((ToneModule) => {
      // Holds the sound of the note we are playing
      const samplerModule = new ToneModule.Sampler({
        release: 2.5,
        volume: -15,
        urls: {
          [note]: `/pre-session-notes/${note}.mp3`,
        },
      });

      // Softens the sound of the note when it plays
      const reverbModule = new ToneModule.Reverb({
        decay: 5,
        preDelay: 0.1,
      });

      return samplerModule.connect(reverbModule).toDestination();
    });
  }
  return globalSamplers[note];
}
